<template>
  <app-status-badge design="new" :compact="compact" :tone="meta.tone" :label="meta.label" />
</template>

<script>
import { statusMeta } from '../importState'

export default {
  name: 'CrewImportStatusBadge',
  props: {
    status: { type: String, required: true },
    compact: { type: Boolean, default: false }
  },
  computed: {
    meta() { return statusMeta(this.status) }
  }
}
</script>
